import { IconChevronLeft } from '@tabler/icons-react'
import { ReactNode } from 'react'

import { AstraButton, AstraHeading, AstraIcon, astraTwMerge } from '~/astra'

export type DialogCrumb = {
    title: string
    icon?: ReactNode
    onClick?: () => void
}

export const DialogBreadcrumb = ({ title, icon, onClick }: DialogCrumb) => (
    <span className={astraTwMerge('flex items-center gap-1', onClick ? 'cursor-pointer' : '')} onClick={onClick}>
        {icon}
        <AstraHeading as="h3" weight="regular">
            {title}
        </AstraHeading>
    </span>
)

export type DialogBreadcrumbsHeaderProps = {
    crumbs: DialogCrumb[]
    onBackClick: () => void
}

export const DialogBreadcrumbsHeader = ({ crumbs, onBackClick }: DialogBreadcrumbsHeaderProps) => (
    <div className="flex items-center gap-2">
        <AstraButton variant="ghost" icon={<AstraIcon icon={IconChevronLeft} />} size="large" onClick={onBackClick} />
        <span className="flex divide-x [&>span:not(:first-child)]:pl-4 [&>span:not(:last-child)]:mr-4">
            {crumbs.map((crumb, index) => (
                <DialogBreadcrumb key={index} {...crumb} />
            ))}
        </span>
    </div>
)
